module.exports = __webpack_public_path__ + "img/Widget.f63f1376.svg";